import axios from "axios";
import { getApiBaseUrl } from "../constants";
export function API() {
    var instance = axios.create({
        baseURL: getApiBaseUrl(),
        headers: {
            accept: 'application/json',
        }
    });
    return {
        get authenticated() {
            return instance;
        }
    };
}
